export { default } from './IntroBlockLeadText'
